import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MessageModalComponent } from './message-modal/message-modal.component';
import { TranslateModule } from '@ngx-translate/core';
import { TableComponent } from './table/table.component';
import { TableModule } from 'primeng/table';
import { LetDirective, PushPipe } from '@ngrx/component';
import { ButtonModule } from 'primeng/button';
import { ToolbarComponent } from './toolbar/toolbar.component';
import { PasswordStrengthComponent } from './password-strength/password-strength.component';

@NgModule({
    declarations: [MessageModalComponent, TableComponent, ToolbarComponent, PasswordStrengthComponent],
    exports: [TableComponent, PasswordStrengthComponent],
    imports: [CommonModule, TranslateModule, TableModule, TranslateModule, LetDirective, ButtonModule, PushPipe]
})
export class SharedModule {}
